import { Menu, MenuList, NonMenuList } from '../../models/menu';
import { PermissionCode } from '../../enums/permission-code';

function flattenRoutePermissions(
  items: Menu[],
  parentPath = '',
): Record<string, string> {
  return items.reduce<Record<string, string>>((map, item) => {
    const path = parentPath ? `${parentPath}/${item.route}` : item.route;
    map[path] = item.permission;

    if (item.sub.length) {
      Object.assign(map, flattenRoutePermissions(item.sub, path));
    }

    return map;
  }, {});
}

// Routes that require a permission but aren't represented in the sidebar menu
// (dynamic sub-pages of a menu entry, or menu-less aliases of one).
const SUPPLEMENTAL_ROUTE_PERMISSIONS: Record<string, string> = {
  search: [
    PermissionCode.CUSTOM_BUSINESS_RECORD,
    PermissionCode.ACCESS_DATA_AXLE,
    PermissionCode.ACCESS_CRF,
    PermissionCode.ACCESS_DEEPROOTS,
  ].join('|'),
  'deeproots/leads-criteria/details/:id':
    PermissionCode.MANAGE_MATCHING_CRITERIA,
  'deeproots/leads-criteria/create': PermissionCode.MANAGE_MATCHING_CRITERIA,
};

const ROUTE_PERMISSION_MAP: Record<string, string> = {
  ...flattenRoutePermissions(MenuList),
  ...flattenRoutePermissions(NonMenuList),
  ...SUPPLEMENTAL_ROUTE_PERMISSIONS,
};

export function getPermissionForRoutePath(
  path: string | undefined,
): string | undefined {
  if (!path) {
    return undefined;
  }
  return ROUTE_PERMISSION_MAP[path];
}
